<template>
  <div>
    <h4 class="modal__header">
      Bulk Upload Member
      <img
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
        @click="$emit('close')"
      />
    </h4>
    <div class="modal__content">
      <p class="mb-2">
        Please download the template for the bulk upload of members.
      </p>
      <center class="mb-2">
        <a href="http://bit.ly/qs-member-template" download>
          <action-button
            class="mt-0 d-inline-block w-auto"
            label="Download Template"
            :theme="{ primary, secondary, event, danger }"
          ></action-button>
        </a>
      </center>
      <hr />
      <div class="alert alert-danger" v-for="(err, i) of errors" :key="i">
        {{ err.message }}
      </div>
      <p class="mb-2">Upload file here:</p>

      <form
        method="POST"
        enctype="multipart/form-data"
        ref="media"
        @submit.prevent="handleSubmit($event)"
      >
        <div class="row mx-0">
          <div class="col p-0">
            <div class="form-group">
              <div class="row">
                <div class="col-3">
                  <ActionButton
                    label="Choose file"
                    @customEvent="$refs.file.click()"
                    style="width: 100%; margin-top: 0;"
                    :theme="{ primary, secondary, event, danger }"
                  />
                </div>
                <div class="col-7">
                  <input
                    @click="$refs.file.click()"
                    type="text"
                    v-model="fileName"
                    class="form-control"
                    style="cursor: pointer;"
                    readonly
                  />
                </div>
                <div class="col-2">
                  <ActionButton
                    :theme="{ primary, secondary, event, danger }"
                    type="submit"
                    style="width: auto; margin-top: 0;"
                    label="Upload"
                  />
                </div>
              </div>
              <input
                class="col-8 col-sm-10 form-control d-none"
                ref="file"
                name="file"
                type="file"
                @change="handleChange"
                required
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/axios";
import { mapActions } from "vuex";
import { signupViaBulkUpload } from "@/helpers/mailer";

export default {
  components: {
    ActionButton
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  data: () => ({
    fileName: "",
    message: "",
    errors: []
  }),
  methods: {
    ...mapActions({
      USERS_ADD: "USERS_ADD"
    }),
    handleChange(e) {
      this.fileName = e.target.files[0].name;
    },
    handleSubmit() {
      this.$swal({
        title: "Have you added everything?",
        text: "The user will be emailed along with their password",
        type: "info",
        showCancelButton: true,
        confirmButtonText: "Upload",
        reverseButtons: true
      }).then(async result => {
        this.$emit("fetching", true);
        if (result.value) {
          const form = new FormData(this.$refs.media);
          await axios
            .upload("/users/bulk-upload", form)
            .then(async response => {
              this.USERS_ADD(response.data.data);
              for (const user of response.data.data) {
                const email = await signupViaBulkUpload({
                  to: user.email,
                  displayName: user.displayName,
                  resetTokenUrl:
                    location.origin + "/reset?token=" + user.passwordResetToken
                });
                console.log(email);
              }
              this.$emit("fetching", false);
              this.$emit("close");
            })
            .catch(error => {
              this.errors = error.response.data.errors;
            });
        }
      });
    }
  }
};
</script>

<style></style>
